import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { testimonials } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Testimonials() {
  return <section className="w-full bg-navy px-4 py-14 sm:px-6 sm:py-20" data-id="element-266" data-mp="3mh29lqvhf8e0">
      <div className="mx-auto max-w-3xl" data-id="element-267" data-mp="3mepkmtrb3xrg">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-268" data-mp="3r7sg57fn9haa">
          Cosa dicono gli altri professionisti
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-white sm:text-4xl" data-id="element-269" data-mp="3ahgee7sel5">
          Professionisti che stanno già pianificando con un sistema
        </h2>

        <div className="mt-9 space-y-4" data-id="element-270" data-mp="8zt79hr5fmdi">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="rounded-3xl bg-white p-5 shadow-card sm:p-6" data-id="element-271" data-mp="e07gh34hl2d4">
              <div className="flex items-center gap-1" aria-label="Valutazione 5 su 5" data-id="element-272" data-mp="2av3pgbt0jrlj">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-273" data-mp="1sk9ewqsi2wgb" />)}
              </div>
              <QuoteIcon className="mt-3 h-5 w-5 text-brand/40" aria-hidden="true" data-id="element-274" data-mp="1ns9k1craetql" />
              <blockquote className="mt-2 text-[14.5px] leading-relaxed text-navy/85 sm:text-[15.5px]" data-id="element-275" data-mp="1ivj20jvx9o2j">
                {testimonial.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-navy/10 pt-4" data-id="element-276" data-mp="2bjx172yqyqfo">
                <img src={testimonial.photo} alt={`Ritratto di ${testimonial.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover" width={96} height={96} loading="lazy" data-id="element-277" data-mp="26jsj58i6xnnc" />
                <div className="min-w-0" data-id="element-278" data-mp="r43804s1cz2a">
                  <p className="font-display text-[15px] font-bold leading-tight text-navy" data-id="element-279" data-mp="r4v37ehq0us1">{testimonial.name}</p>
                  <p className="mt-0.5 text-[12.5px] leading-tight text-navy/60" data-id="element-280" data-mp="m6jtr4vc8mac">{testimonial.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <CtaBlock className="mt-9" label="Unisciti a loro per €19" tone="dark" data-id="element-281" data-mp="simo28iytoec" />
      </div>
    </section>;
}